import React from 'react';
import { Grid } from '@mui/material';
import { Trans } from '@gamiphy/react-i18n';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { WelcomeGiftStore, WelcomeGiftTypes } from '@gamiphy/loyalty-station-desktop/store/welcomeGift';
import { DiscountsStore } from '@gamiphy/loyalty-station-desktop/store/discounts';
import WelcomeCouponCard from './components/WelcomeCouponCard';
import WelcomePointsCard from './components/WelcomePointsCard';

const WelcomeGiftPage: React.FC = () => {
  const description = React.useMemo(() => {
    switch (WelcomeGiftStore.type) {
      case WelcomeGiftTypes.points:
        return (
          <Trans
            i18nKey="welcomeGift.congrats.points.description"
            defaults="You've unlocked your welcome {{, gems}}"
            values={{}}
          />
        );
      case WelcomeGiftTypes.discount:
        if (DiscountsStore.welcomeGiftDiscount?.cashbackConfig.minRedemptionValue) {
          return (
            <Trans
              i18nKey="welcomeGift.congrats.discount.descriptionWithMinOrderValue"
              defaults="Your coupon can be used in purchases over {{minOrderValue,currency}}."
              values={{
                minOrderValue: DiscountsStore.welcomeGiftDiscount?.cashbackConfig.minRedemptionValue,
              }}
            />
          );
        }
        return null;

      default:
        return null;
    }
  }, [WelcomeGiftStore.type]);

  const content = React.useMemo(() => {
    switch (WelcomeGiftStore.type) {
      case WelcomeGiftTypes.discount:
        return (
          <WelcomeCouponCard />
        );
      case WelcomeGiftTypes.points:
        return (
          <WelcomePointsCard />
        );
      default:
        return null;
    }
  }, [WelcomeGiftStore.type]);

  return (
    <Grid
      container
      direction="column"
      wrap="nowrap"
      sx={(theme) => ({ color: theme.palette.text.secondary })}
    >
      <Grid
        sx={(theme) => ({
          p: theme.spacing(2),
          color: theme.palette.text.primary,
          fontSize: '2.1rem',
          fontWeight: 500,
        })}
      >
        <Grid container direction="column" spacing={1}>
          <Grid>
            <Trans
              i18nKey="welcomeGift.congrats.title"
              defaults="Congrats, {{firstName}}! 🎉"
              values={{
                firstName: UserStore.user?.firstName ?? '',
              }}
            />
          </Grid>
          <Grid sx={{ fontSize: '1.4rem', fontWeight: 'normal' }}>
            {description}
          </Grid>
        </Grid>
      </Grid>
      <Grid sx={(theme) => ({ flex: 2, p: theme.spacing(2) })}>
        {content}
      </Grid>
    </Grid>
  );
};

export default WelcomeGiftPage;
